import React, { Component } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import PropTypes from "prop-types";
import ScrollMenu from "react-horizontal-scrolling-menu";
import "./System.css";
import "./Mobile.css";
import FontAwesome from 'react-fontawesome';
import left from "../../assets/icons/back.png";
import right from "../../assets/icons/next.png";
import Home from "../HomePage/Index";
import Cookies from "universal-cookie";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../Actions/Index";
var cookie = new Cookies();

const list = [

    { name: "Khaadi", value: "1" },
    { name: "Limelight", value: "2" },
    { name: "Sapphire", value: "3" },
    { name: "Gulahmed", value: "4" },
    { name: "J. | JunaidJamshed", value: "5" },
    { name: "Ittehad Textiles", value: "6" },
    { name: "Waniya", value: "7" },
    { name: "Shoes", value: "10" },
    { name: "Jewellery", value: "11" },
    { name: "Dress", value: "12" },
    { name: "Bed Sheet", value: "13" },
    { name: "2PC", value: "14" },
    { name: "3PC", value: "15" },
    { name: "Stitched", value: "16" },
    { name: "Unstitched", value: "17" },
    { name: "Red", value: "18" },
    { name: "Green", value: "17" },
    { name: "Blue", value: "17" },
    { name: "Pink", value: "17" },
    { name: "Yellow", value: "17" }
];
const list2= [
  {color:'#F44336'},
  {color:'#2196F3'},
  {color:'#E91E63'},
  {color:'white'},
  {color:'grey'},
  {color:'black'}
 
  
];
function handleChipClick(event){


}

const MenuItem = ({ text,clas,selected }) => {
  return (<div onClick={(event) => handleChipClick(event)}  className={`pn-ProductNav_LinkS ${clas}`} >
  <div className="innerS">
{text}
  </div>
  </div>);
};

export const Menu = (list, selected) =>
  list.map(el => {
    const { name } = el;
    var cls;
    if(selected===name) cls="borderUp";
    else
    cls="Simple";
    return <MenuItem text={name} clas={cls} key={name} selected={selected} />;
  });

const Arrow = ({ text, className }) => {
  return <div className={className}>
  {  text===">"? <img  className="arrR" src={right}></img>:<img className="arrL" src={left}></img>
  }
  </div>;
};
Arrow.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

export const ArrowLeft = Arrow({ text: "<", className: "arrow-prev" });
export const ArrowRight = Arrow({ text: ">", className: "arrow-next" });

class Navsystem extends Component {
  state = {
    alignCenter: true,
    clickWhenDrag: false,
    dragging: true,
    hideArrows: true,
    hideSingleArrow: true,
    itemsCount: list?.length,
    selected: null,
    translate: 0,
    transition: 0.3,
    wheel: true,

    activateColor:null,
    activateFilter:null,
    productCatList: [],

    loadingBarProgress: 0,
    loaded: true,
    onload: true,
    showItems: 20,
    success: false,
    error: false,
    hasMore: true,
    isLoading: false,


    shown:false

  };

  constructor(props) {
    super(props);
    this.menu = null;
    this.menuItems = Menu(list.slice(0, list?.length), this.state.selected);
  }
  componentWillMount(){
  }

  onUpdate = ({ translate }) => {
    this.setState({ translate });
  };

 filterData = (Brand_name,keyi)=>{
   return Brand_name.Brand_Name == keyi;
 }

  onSelect = keyi => {
   
    if(this.state.selected!==keyi){
      var array= this.props.JigarProduct;
    this.setState({ selected: keyi });
    console.log(keyi)
    console.log(array.filter((array,keyi) => this.filterData(array,`${keyi.toString()}`)))
  }
   if(this.state.selected===keyi){
    console.log(`onSelect: ${null}`);
    this.setState({ selected: null });
  }
  };

  componentDidUpdate(prevProps, prevState) {
    const { alignCenter } = prevState;
    const { alignCenter: alignCenterNew } = this.state;
    if (alignCenter !== alignCenterNew) {
      this.menu.setInitial();
    }
  }

  setItemsCount = ev => {
    const { itemsCount = list?.length, selected } = this.state;
    const val = +ev.target.value;
    const itemsCountNew =
      !isNaN(val) && val <= list?.length && val >= 0
        ? +ev.target.value
        : list.length;
    const itemsCountChanged = itemsCount !== itemsCountNew;

    if (itemsCountChanged) {
      this.menuItems = Menu(list.slice(0, itemsCountNew), selected);
      this.setState({
        itemsCount: itemsCountNew
      });
    }
  };

  setSelected = ev => {
    const { value } = ev.target;
    this.setState({ selected: String(value) });
  };


  

  render() {
    const {
      alignCenter,
      clickWhenDrag,
      hideArrows,
      dragging,
      hideSingleArrow,
      selected,
      translate,
      transition,
      wheel
    } = this.state;

    const menu = this.menuItems;
    let bor;
    
    return (
      <div style={{ marginTop: "90px" }}>
      <div className="HeadS">

        <div className="categoriesS">
          <div className='pn-ProductNavS'>
        <ScrollMenu
          ref={el => (this.menu = el)}
          data={menu}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          hideArrows={hideArrows}
          hideSingleArrow={hideSingleArrow}
          transition={+transition}
          onUpdate={this.onUpdate}
          onSelect={this.onSelect}
          selected={selected}
          translate={translate}
          alignCenter={alignCenter}
          scrollToSelected={true}
          dragging={dragging}
          clickWhenDrag={clickWhenDrag}
          wheel={wheel}
        /> 
          </div>
        </div>
        </div>
        <Home
          showItems={this.state.showItems}
          productCatList={this.state.productCatList}
          productsList={this.state.productsList}
        />




      </div>

      
    );
  }
}
const mapStateToProps=(state)=>(

  {
    JigarProduct:state.JigarProduct,
});

const mapDispatchToProps = dispatch => {
  
  return {
    getProductFromMorphJigar: () => dispatch(actionCreators.getProductFromMorphJigar()),
  }
  
}
export default  withRouter(connect(mapStateToProps,mapDispatchToProps)(Navsystem))

//ReactDOM.render(<App />, document.getElementById("root"));
